import React from "react";
import { useFormik } from "formik";
import { validate } from "../../_common/Validation";
import { AuthPost } from "../../_common/httpService";
import { forgetpwValidate } from "../../_common/Validation";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Toast from "../../Components/Toast";
import { toast } from "react-hot-toast";
import { Carousel } from "react-responsive-carousel";
import mainLogo from "../../assets/slices/main_logo.svg";
import welcome from "../../assets/slices/welcome_img.png";
import BannertwoImg from "../../assets/slices/bannertwo.png";
import BannerthreeImg from "../../assets/slices/bannerthree.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
const ForgotPassword = () => {
  const navigate = useNavigate();
  const { values, handleChange, handleSubmit, handleBlur, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
      },
      validate: forgetpwValidate,
      onSubmit: (values) => {
        let data = values;
        AuthPost("tenant/forgot-password", data)
          .then((res) => {
            if (res.statusCode === 200) {
              
              toast.success("Reset password link sent Successfully");
              setTimeout(() => {
                navigate("/");
              }, 1000); 
              
            
            } else {
              toast.error("Email not exist");

              setTimeout(() => {
                navigate("/");
              }, 1000); 
            }
          })
          .catch((err) => {
            console.log('err::: ', err);

          });
      },
    });
  return (
    <>  
      <Toast /> 
      <div className="fullScreen_bg displayFlex Alignitem_center">
        <div className="container_wrapper">
          <div className="row Customerpanel_rectangle whiteBg height_600">
            <div className="ColumnLeft col-md-5 pzero">
              <Carousel
                infiniteLoop
                useKeyboardArrows
                autoPlay
                showThumbs={false}
                showStatus={false}
                showArrows={false}
              >
                <div className="welcome_content">
                  <img src={welcome} />
                  <h3>Welcome to Glenzy </h3>
                  <p>
                    Transforming your fintech dream into reality with our
                    seamless and innovative Tech solutions
                  </p>
                </div>

                <div className="welcome_content">
                  <img src={BannertwoImg} />
                  <h3>Welcome to Glenzy</h3>
                  <p>
                    Transforming your fintech dream into reality with our
                    seamless and innovative Tech solutions
                  </p>
                </div>

                <div className="welcome_content">
                  <img src={BannerthreeImg} />
                  <h3>Welcome to Glenzy</h3>
                  <p>
                    Transforming your fintech dream into reality with our
                    seamless and innovative Tech solutions
                  </p>
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 pzero displayFlex Alignitem_center justifyContent_center ">
              <div className="mobWidth100per">
                {/* <div className="mb_24 textAlign_center">
                  <img src={mainLogo} />
                </div> */}

                <h3 className="fontSize24 blackText fontWeight_500 textAlign_center">
                  Forgot Your Password?
                </h3>
                <p className="subparagraph_text mb_24">
                  Check your email for your password reset.
                </p>
                {/* <div className="title_border mb_30"></div> */}
                <form onSubmit={handleSubmit} className="account_frame">
                  <div className="  mb_24">
                    <input
                      type="text"
                      className="Main_input"
                      id="email"
                      placeholder="Enter Email Address"
                      name="email"
                      autoComplete="off"
                      value={values.email?.replace(/[ ]/g, "")}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.email && touched.email ? (
                      <div className="error_text">{errors.email}</div>
                    ) : null}
                  </div>

                  <button type="submit" className="Mainbutton">
                    Submit
                  </button>
                </form>
                <div className="textAlign_center mt_24">
      <span
        className="cursorpointer"
        onClick={() => {
          navigate(`/login`);
        }}
      >
        Back to login
      </span>
    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
